import {
  Container
} from "unstated";
import slugify from "slugify";
import _ from "lodash";

import config from "./shards-pro/config.json";

class AppStateContainer extends Container {
  constructor() {
    super();

    // parse initial state.
    const initialState = config.categories.map((category, index) => {
      category.id = slugify(category.title + index);
      category.items = category.items.map((item) => {
        return {
          ...item,
          ...{
            loaded: false
          }
        };
      });

      return category;
    })

    this.state = {
      categories: initialState
    }
  }

  setElementAsLoaded(idx, cidx) {
    const newState = {
      ...this.state
    };
    newState.categories[cidx].items[idx].loaded = true;
    this.setState(newState);
  }

  resizeFrame(type, cidx, idx) {
    const newState = {
      ...this.state
    };
    const classes = _.filter(newState.categories[cidx].items[idx].classes, (i) => {
      return ['tablet', 'laptop', 'smartphone'].indexOf(i) === -1;
    });
    classes.push(type);

    newState.categories[cidx].items[idx].classes = classes;
    this.setState(newState);
  }

  resetLoadedState() {
    const newState = {
      ...this.state
    };

    newState.categories.map(c => c.items.map(i => {
      i.loaded = false;
      return i;
    }));

    this.setState(newState);
  }
}

export default AppStateContainer;